import { Card } from './PanelCard.styles';
import type { PanelCardProps } from './PanelCard.types';

export function PanelCard({ children }: PanelCardProps) {
  return <Card>{children}</Card>;
}
